import { render, staticRenderFns } from "./BasketballMatches.vue?vue&type=template&id=3fb4000e&"
import script from "./BasketballMatches.vue?vue&type=script&lang=js&"
export * from "./BasketballMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports